var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_c('h1',[_vm._v("404")]),_c('p',{staticClass:"body-2"},[_vm._v(" Parece que la página que buscas no existe. Intenta navegar a otra página. ")])])
}]

export { render, staticRenderFns }